// OWNER URLS
// Owner
export const OWNER_REPORT_BY_DAY = "/dashboard/v2/reports/report_by_day";
export const OWNER_REPORT_BY_HOUR = "/dashboard/v2/reports/report_by_hour";
export const OWNER_REPORT_PACKAGE_BY_DAY = "/dashboard/v2/reports/report_package_by_day";
export const OWNER_REPORT_PACKAGE_BY_HOUR = "/dashboard/v2/reports/report_package_by_hour";
export const OWNER_REPORT_SERVICE_TYPE_BY_DAY = "/dashboard/v2/reports/report_service_type_by_day";
export const OWNER_REPORT_SERVICE_TYPE_BY_HOUR = "/dashboard/v2/reports/report_service_type_by_hour";
export const OWNER_REPORT_DINE_IN_COVERS_BY_DAY = "/dashboard/v2/reports/report_cover_dine_in_by_day";
export const OWNER_REPORT_SALES_AND_RATING = "/dashboard/v2/reports/report_sales_and_rating";
export const OWNER_REPORT_SOLD_OUT = "/dashboard/v2/reports/report_sold_out";
export const OWNER_REPORT_SOLD_OUT_BY_DATE = "/dashboard/v2/reports/report_sold_out_per_date";
// Group
export const GROUP_REPORT_BRANCH_COVERS_BY_HOUR = "/dashboard/v2/group/reports/report_branch_covers_by_hour";
export const GROUP_REPORT_BY_DAY = "/dashboard/v2/group/reports/report_by_day";
export const GROUP_REPORT_BY_HOUR = "/dashboard/v2/group/reports/report_by_hour";
export const GROUP_REPORT_PACKAGE_BY_DAY = "/dashboard/v2/group/reports/report_package_by_day";
export const GROUP_REPORT_PACKAGE_BY_HOUR = "/dashboard/v2/group/reports/report_package_by_hour";
export const GROUP_REPORT_SERVICE_TYPE_BY_DAY = "/dashboard/v2/group/reports/report_service_type_by_day";
export const GROUP_REPORT_SERVICE_TYPE_BY_HOUR = "/dashboard/v2/group/reports/report_service_type_by_hour";
export const GROUP_REPORT_DINE_IN_COVERS_BY_DAY = "/dashboard/v2/group/reports/report_cover_dine_in_by_day";
export const GROUP_REPORT_SALES_AND_RATING = "/dashboard/v2/group/reports/report_sales_and_rating";
export const GROUP_REPORT_SOLD_OUT = "/dashboard/v2/group/reports/report_sold_out";
export const GROUP_REPORT_SOLD_OUT_BY_DATE = "/dashboard/v2/group/reports/report_sold_out_per_date";

// ADMIN URLS
export const ADMIN_USER_SHOW = "/admin/users";
export const ADMIN_CREDIT_CARD_CHECK_STATUS = "/admin/credit_cards/check_status";

// BLOGGER URLS
export const BLOGGER_UTM_LINK = "/p/utm_link";